"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTempData = void 0;
var _react = require("react");
var _AudiencePickerProvider = require("../AudiencePickerProvider.helpers");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var emptyArray = [];
var useTempData = function useTempData() {
  var studentsIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyArray;
  var singleStudentsIds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyArray;
  var classesMapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var groupsMapper = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var studentsMapper = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var _useState = (0, _react.useState)({
      selectedGroupsIds: [],
      selectedClassesIds: []
    }),
    _useState2 = _slicedToArray(_useState, 2),
    groupsSelectorTempData = _useState2[0],
    setGroupsSelectorTempData = _useState2[1];
  var _useState3 = (0, _react.useState)({
      selectedStudentsIds: [],
      groupSearchText: '',
      isGroupSearchOpen: false,
      studentsSearchText: '',
      isStudentsSearchOpen: false,
      selectedGroup: ''
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    studentsSelectorTempData = _useState4[0],
    setStudentsSelectorTempData = _useState4[1];
  var _useState5 = (0, _react.useState)({
      groupName: '',
      newGroupName: '',
      groupId: ''
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    createGroupTempData = _useState6[0],
    setCreateGroupTempData = _useState6[1];
  (0, _react.useEffect)(function () {
    var isOn = false;
    var onClick = function onClick() {
      setStudentsSelectorTempData(_objectSpread(_objectSpread({}, studentsSelectorTempData), {}, {
        isGroupSearchOpen: false
      }));
    };
    if (studentsSelectorTempData.isGroupSearchOpen) {
      isOn = true;
      document.addEventListener('click', onClick);
    }
    return function () {
      if (isOn) {
        document.removeEventListener('click', onClick);
      }
    };
  }, [studentsSelectorTempData, studentsSelectorTempData.isGroupSearchOpen, studentsSelectorTempData.groupSearchText]);
  var getStudentsSearchList = (0, _react.useCallback)(function () {
    var getStudentsList = function getStudentsList() {
      if (!studentsSelectorTempData.isStudentsSearchOpen) {
        var _classesMapper$studen, _groupsMapper$student;
        if (studentsSelectorTempData.selectedGroup === 'all') {
          return studentsIds;
        } else if (studentsSelectorTempData.selectedGroup === 'singleStudents') {
          return singleStudentsIds;
        }
        return classesMapper && ((_classesMapper$studen = classesMapper[studentsSelectorTempData.selectedGroup]) === null || _classesMapper$studen === void 0 ? void 0 : _classesMapper$studen.studentIds) || groupsMapper && ((_groupsMapper$student = groupsMapper[studentsSelectorTempData.selectedGroup]) === null || _groupsMapper$student === void 0 ? void 0 : _groupsMapper$student.studentIds) || [];
      }
      if (!studentsSelectorTempData.studentsSearchText || studentsSelectorTempData.studentsSearchText.length < 2) {
        return [];
      }
      var studentsListMapper = {};
      studentsSelectorTempData.studentsSearchText.toLowerCase().split(' ').filter(function (key) {
        return !!key;
      }).sort(function (a, b) {
        var aLength = a.length;
        var bLength = b.length;
        if (aLength < bLength) {
          return 1;
        }
        if (aLength > bLength) {
          return -1;
        }
        return 0;
      }).forEach(function (key) {
        studentsIds === null || studentsIds === void 0 ? void 0 : studentsIds.forEach(function (id) {
          if (studentsMapper && studentsMapper[id] && (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student).indexOf(key) >= 0) {
            if (!studentsListMapper[id]) {
              studentsListMapper[id] = {
                id: id,
                key: '',
                fullName: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student),
                fullNameHtml: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student)
              };
            }
            var re = new RegExp(key, 'gi');
            studentsListMapper[id].key += key;
            studentsListMapper[id].fullNameHtml = studentsListMapper[id].fullNameHtml.replace(re, "<span>".concat(key, "</span>"));
          }
        });
      });
      return Object.keys(studentsListMapper).sort(function (a, b) {
        var aKeyLength = studentsListMapper[a].key.length;
        var bKeyLength = studentsListMapper[b].key.length;
        if (aKeyLength < bKeyLength) {
          return 1;
        }
        if (aKeyLength > bKeyLength) {
          return -1;
        }
        if ((0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[a]) < (0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[b])) {
          return -1;
        }
        if ((0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[a]) > (0, _AudiencePickerProvider.getStudentFullName)(studentsListMapper[b])) {
          return 1;
        }
        return 0;
      }).map(function (id) {
        return studentsListMapper[id];
      });
    };
    if (studentsSelectorTempData && studentsIds && studentsMapper && classesMapper && groupsMapper) {
      return getStudentsList();
    }
    return [];
  }, [classesMapper, groupsMapper, singleStudentsIds, studentsIds, studentsMapper, studentsSelectorTempData]);
  return {
    groupsSelectorTempData: groupsSelectorTempData,
    setGroupsSelectorTempData: setGroupsSelectorTempData,
    studentsSelectorTempData: studentsSelectorTempData,
    setStudentsSelectorTempData: setStudentsSelectorTempData,
    createGroupTempData: createGroupTempData,
    setCreateGroupTempData: setCreateGroupTempData,
    getStudentsSearchList: getStudentsSearchList
  };
};
exports.useTempData = useTempData;